export default __webpack_public_path__ + "static/media/swap.bd75b9c9.svg";